export default class CreateTransferOrder {
  srcWarehouseCode: string;
  dstWarehouseCode: string;
  assetTypeCode: string;
  conditionTypeCode: string;
  clientCode: string;
  note: string;
  isNoPack: boolean;
  productType: string;
  autoCreateSo:boolean;
  items: Array<any>;
}
